export function validateRange(
  value: number | null | undefined,
  min: number,
  max: number,
  label: string
): string | null {
  if (value === null || value === undefined || String(value) === '' || isNaN(Number(value))) {
    return `${label} is required.`;
  }
  if (value <= 0) return `${label} must be greater than 0.`;
  if (value < min) return `Minimum ${label.toLowerCase()} is ${min.toLocaleString('en-IN')}.`;
  if (value > max) return `Maximum ${label.toLowerCase()} is ${max.toLocaleString('en-IN')}.`;
  return null;
}

// Same as validateRange but permits 0 (and min = 0), for fields like "current savings" that are legitimately zero.
export function validateRangeAllowZero(
  value: number | null | undefined,
  min: number,
  max: number,
  label: string
): string | null {
  if (value === null || value === undefined || String(value) === '' || isNaN(Number(value))) {
    return `${label} is required.`;
  }
  if (value < min) return `Minimum ${label.toLowerCase()} is ${min.toLocaleString('en-IN')}.`;
  if (value > max) return `Maximum ${label.toLowerCase()} is ${max.toLocaleString('en-IN')}.`;
  return null;
}
